import { session } from 'auth/session'
import { useLocation } from 'react-router-dom'
import { useOrgName } from './useOrgName'

const routesToReset = ['explorer', 'apps']

export const useChangeOrg = () => {
  const { pathname, search } = useLocation()
  const currentOrgName = useOrgName()

  /**
   * Change current org and persist current page if allowed
   */
  const changeOrg = async (newOrgName) => {
    /**
     * Save the org name you're navigating to to localStorage,
     * so if you land back on the '/' path in the future we can
     * try to put you back here
     */
    session.set('selectedOrgName', newOrgName)

    let path = pathname
    /**
     * Extract root page
     */
    const page = pathname.split('/')[2]

    /**
     * Persist the current pathname when changing orgs as long as it's included in the list of pages to reset
     * Check if the page is in the list of pages to reset
     * We are doing this in case current page is an app that might not exist in the target org
     */

    if (routesToReset.includes(page)) {
      path = `/${newOrgName}/${page}`
    } else {
      path = path.replace(`/${currentOrgName}`, `/${newOrgName}`)
    }
    const finalPath = `${path}${search}`

    /**
     * Hard refresh to the root of the new org
     */

    window.location.href = finalPath
  }
  return { changeOrg }
}
